import { render, staticRenderFns } from "./DemoContent.vue?vue&type=template&id=0a588b56"
import script from "./DemoContent.vue?vue&type=script&lang=js"
export * from "./DemoContent.vue?vue&type=script&lang=js"
import style0 from "./DemoContent.vue?vue&type=style&index=0&id=0a588b56&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports